import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';

@Component({
  selector: 'app-coursewise-att-thresold-master',
  templateUrl: './coursewise-att-thresold-master.component.html',
  styleUrls: ['./coursewise-att-thresold-master.component.scss']
})
export class CoursewiseAttThresoldMasterComponent implements OnInit {

  APIService: any;
  CourseAtdThreshold: FormGroup;
  dialogRef: MatDialogRef<any>;

  userPermission: any;
  utp: string;
  AtdSettingCreate = true;
  AtdSettingUpdate = true;

  fcCodeList: any[] = [];
  filteredListFcCode: any[] = [];

  CourseList: any[] = [];
  filteredListCourse: any[] = [];
  selectedCourses: any[] = [];

  AtArray: FormArray;
  Table = false;
  SaveBtn = false;
  UpdateBtn = false;
  saveDisable = false;
  updateDisable = false;
  savedpayload: any;
  submitpayload: any;
  errMsg: any;
  isLoadingThreshold = false;

  constructor(
    private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    public router: Router,
    private httpClient: HttpClient,
    private spinner: NgxSpinnerService
  ) {
    this.APIService = environment.serviceUrl;
  }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission'));
    this.utp = sessionStorage.getItem('usertypeee');

    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach((element: any) => {
        if (element.PageName == 'Course Attendance Threshold' && element.PCreate == false) {
          this.AtdSettingCreate = false;
        }
        if (element.PageName == 'Course Attendance Threshold' && element.PUpdate == false) {
          this.AtdSettingUpdate = false;
        }
      });
    }

    this.Table = false;
    this.SaveBtn = false;
    this.UpdateBtn = false;
    this.saveDisable = false;
    this.updateDisable = false;
    this.selectedCourses = [];

    this.CourseAtdThreshold = this.fb.group({
      CoFcCode: new FormControl('', [Validators.required]),
      CoCode:   new FormControl([], [Validators.required]),   // <-- array + required
      AtArray:  new FormArray([])
    });

    this.fetchFacultyCode();
  }

  getAtArrayControls() {
    return (this.CourseAtdThreshold.get('AtArray') as FormArray).controls;
  }

  fetchFacultyCode() {
    this.umsService.getFaculty({}).subscribe((res: any) => {
      if (res.status) {
        this.fcCodeList = res.data || [];
        this.filteredListFcCode = [...this.fcCodeList];
      }
    });
  }

  onFacultyChange(fcCode: any) {
    this.CourseAtdThreshold.patchValue({ CoCode: [] });
    this.selectedCourses = [];
    this.CourseList = [];
    this.filteredListCourse = [];
    this.AtArray = this.CourseAtdThreshold.get('AtArray') as FormArray;
    this.AtArray.clear();
    this.Table = false;
    this.SaveBtn = false;
    this.UpdateBtn = false;

    if (fcCode) {
      this.getCourse(fcCode);
    }
  }

  getCourse(facultyCode) {
    this.spinner.show();
    const payload = { CoFcCode: facultyCode };

    this.umsService.getCourse(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.CourseList = res.data;
          this.filteredListCourse = [...this.CourseList];
        } else {
          this.CourseList = [];
        }
        this.spinner.hide();
      },
      error: () => {
        this.CourseList = [];
        this.spinner.hide();
      }
    });
  }


  onSelectAllCourses() {
    const allCodes = this.filteredListCourse.map(x => x.CoCode);

    if (this.isAllCoursesSelected()) {
      this.selectedCourses = [];
    } else {
      this.selectedCourses = allCodes;
    }

    this.CourseAtdThreshold.controls['CoCode'].setValue(this.selectedCourses, { emitEvent: false });

    this.onCourseSelect({ value: this.selectedCourses });
  }

  onCourseSelect(event: any) {
    const selected = event.value.filter(v => v !== 'selectAll');
    this.selectedCourses = selected;

    this.CourseAtdThreshold.get('CoCode').setValue(selected, { emitEvent: false });

    this.AtArray = this.CourseAtdThreshold.get('AtArray') as FormArray;
    this.AtArray.clear();
    this.Table = false;
    this.SaveBtn = false;
    this.UpdateBtn = false;

    if (selected.length > 0) {
      this.getCourseThreshold();
    }
  }

  isAllCoursesSelected(): boolean {
    return (
      this.filteredListCourse.length > 0 &&
      this.selectedCourses.length === this.filteredListCourse.length
    );
  }

  /* ================ Fetch via SP ================ */

  getCourseThreshold() {
    if (this.isLoadingThreshold) return;
    this.isLoadingThreshold = true;

    this.spinner.show();
    this.savedpayload = this.CourseAtdThreshold.value;
    this.AtArray = this.CourseAtdThreshold.get('AtArray') as FormArray;
    this.AtArray.clear();

    const coCodeValue = this.savedpayload.CoCode;

    const payload = {
      CoCode: Array.isArray(coCodeValue) ? coCodeValue.join(',') : coCodeValue,
      SearchString: '',
      PageSize: 10000,
      PageNumber: 1
    };

    this.umsService.getCourseAtdThreshold(payload).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.isLoadingThreshold = false;

        if (res.status) {
          this.Table = true;
          this.loadThresholdTable(res.data);

          const isAllNull = res.data.every(
            (item) => item.TheoryPct === null && item.PracticalPct === null
          );
          const hasValue = res.data.some(
            (item) => item.TheoryPct !== null || item.PracticalPct !== null
          );

          this.SaveBtn = isAllNull;
          this.UpdateBtn = !isAllNull && hasValue;
        } else {
          this.Table = false;
          this.SaveBtn = false;
          this.UpdateBtn = false;
        }
      },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        this.isLoadingThreshold = false;
        this.Table = false;
      }
    );
  }

  loadThresholdTable(data: any[]) {
    this.AtArray = this.CourseAtdThreshold.get('AtArray') as FormArray;
    this.AtArray.clear();

    data.forEach((row, index) => {
      this.AtArray.push(this.createRow(row, index));
    });
  }

  createRow(element: any, index: number): FormGroup {
    return this.fb.group({
      SrNo:         index + 1,
      CatId:        element.CatId ?? '',
      CoCode:       element.CoCode,
      CoName:       element.CoName,
      TheoryPct:    [element.TheoryPct ?? '', [Validators.required, Validators.min(0), Validators.max(100)]],
      PracticalPct: [element.PracticalPct ?? '', [Validators.required, Validators.min(0), Validators.max(100)]],
      IsActive:     element.IsActive ?? 'Y',
      UserId:       element.UserId ?? '',
      isModified:   false
    });
  }


  onInputChange(val, i, field) {
    this.saveDisable = false;
    this.updateDisable = false;

    const tempData = val.target.value;
    const array = this.CourseAtdThreshold.get('AtArray') as FormArray;
    const ctrl = array.controls[i].get(field);

    let errors: any = null;
    if (tempData === '' || tempData === null || tempData === undefined) {
      errors = { required: true };
    } else if (/[^0-9]/.test(String(tempData))) {
      errors = { NonNumericError: true };
    } else if (Number(tempData) > 100) {
      errors = { PercentError: true };
    }

    ctrl.setErrors(errors);

    if (ctrl.errors) {
      if (this.SaveBtn) this.saveDisable = true;
      else if (this.UpdateBtn) this.updateDisable = true;
    }
  }

  onThresholdChange(index: number) {
    const row = this.AtArray.at(index) as FormGroup;
    row.patchValue({ isModified: true });
  }


  Save() {
    if (this.CourseAtdThreshold.invalid) {
      this.CourseAtdThreshold.get('CoFcCode').markAsTouched();
      this.CourseAtdThreshold.get('CoCode').markAsTouched();
      this.AtArray = this.CourseAtdThreshold.get('AtArray') as FormArray;
      this.AtArray.controls.forEach(el => {
        el.get('TheoryPct').markAsTouched();
        el.get('PracticalPct').markAsTouched();
      });
      return;
    }
    this.SaveThreshold();
  }

  SaveThreshold() {
    this.spinner.show();
    this.AtArray = this.CourseAtdThreshold.get('AtArray') as FormArray;

    const rows = this.AtArray.value;
    const userId = this.getUserId();
    let completed = 0;
    let isError = false;
    let lastMsg = '';

    rows.forEach((element) => {
      const payload = {
        CoCode:       element.CoCode,                       // already comma-separated when "All"
        TheoryPct:    parseInt(element.TheoryPct),
        PracticalPct: parseInt(element.PracticalPct),
        UserId:       userId
      };

      this.umsService.saveCourseAtdThreshold(payload).subscribe(
        (res: any) => {
          completed++;
          if (!res.status) { isError = true; lastMsg = res.message; }
          if (completed === rows.length) this.finishOp(isError, lastMsg, 'Saved Successfully');
        },
        (error: HttpErrorResponse) => {
          completed++;
          isError = true;
          lastMsg = error.error?.message || 'Invalid Inputs';
          if (completed === rows.length) this.finishOp(isError, lastMsg, 'Saved Successfully');
        }
      );
    });
  }


  update() {
    if (this.CourseAtdThreshold.invalid) {
      this.CourseAtdThreshold.get('CoFcCode').markAsTouched();
      this.CourseAtdThreshold.get('CoCode').markAsTouched();
      return;
    }
    this.updateThreshold();
  }

  updateThreshold() {
    this.AtArray = this.CourseAtdThreshold.get('AtArray') as FormArray;

    const modifiedRows = this.AtArray.value.filter(r => r.isModified);

    if (modifiedRows.length === 0) {
      this.modalPopupService.openPopup(AlertBoxComponent, {
        message: 'No changes to update',
        title: 'Information',
        icon: 'fas fa-info-circle'
      });
      return;
    }

    this.spinner.show();
    const userId = this.getUserId();
    let completed = 0;
    let isError = false;
    let lastMsg = '';

    modifiedRows.forEach(element => {
      const payload = {
        CoCode:       element.CoCode,
        TheoryPct:    parseInt(element.TheoryPct),
        PracticalPct: parseInt(element.PracticalPct),
        UserId:       userId
      };

      this.umsService.updateCourseAtdThreshold(payload).subscribe(
        (res: any) => {
          completed++;
          if (!res.status) { isError = true; lastMsg = res.message; }
          if (completed === modifiedRows.length) this.finishOp(isError, lastMsg, 'Updated Successfully');
        },
        (error: HttpErrorResponse) => {
          completed++;
          isError = true;
          lastMsg = error.error?.message || 'Invalid Inputs';
          if (completed === modifiedRows.length) this.finishOp(isError, lastMsg, 'Updated Successfully');
        }
      );
    });
  }

  private finishOp(isError: boolean, lastMsg: string, successMsg: string) {
    this.spinner.hide();
    this.modalPopupService.openPopup(AlertBoxComponent, {
      message: isError ? lastMsg : successMsg,
      title: isError ? 'Alert' : 'Information',
      icon: isError ? 'fas fa-close' : 'fas fa-check'
    }).afterClosed().subscribe(() => this.getCourseThreshold());
  }

  private getUserId(): number {
    const fromSession = parseInt(sessionStorage.getItem('userId') || '0', 10);
    if (fromSession) return fromSession;
    if (this.userPermission && this.userPermission[0]) {
      return this.userPermission[0].UserId || this.userPermission[0].UserID || 0;
    }
    return 0;
  }
}